import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie'
import Backbtn from './elements/Backbtn'
import { Footer, Nav, Loader, Analytics } from './elements'

import { documentFetchByBrand } from '../redux/actions'

class Downloaddetail extends Component {

    constructor(){
        super()
        this.state = {
            brand_id: "",
            isLogin: false,
            user: ""
        }
    }

    componentWillMount() {
        if(Cookies.get('user')){
            this.setState({
                isLogin: true,
                user: JSON.parse(Cookies.get('user'))
            })
        } else {
            window.location = "/login"
        }
        let params = this.getParams()
        this.props.documentFetchByBrand(params.brand_id)
        this.setState({
            brand_id: params.brand_id,
        })
    }

    getParams() {
        const searchParams = new URLSearchParams(this.props.location.search);
        return {
            brand_id: searchParams.get('brand_id') || '',
        };
    }

    showDocuments() {
        if(this.props.documents) {
            return this.props.documents.map((item, index) => (
                <div className="each-detail" key={index}>
                    <div className="detail-wrapper">
                        <div className="detail-inner">
                            <h4>{item.name}</h4>
                            <p>{item.description}</p>
                        </div>
                        <a href={item.url} target="_blank" rel="noopener noreferrer" className="btn-download">ดาวน์โหลด</a>
                    </div>
                </div>
            ))
        } else {
            return <Loader />
        }
    }

    render() { 
        if(!this.state.isLogin) return <div></div>
        return ( 
            <div className="page-downloaddetail">
                <Analytics />
                <div className="downloaddetail-header">
                    <Backbtn />
                    <div className="title">
                        <p>{this.props.documents && this.props.documents[0].brand_title}</p>
                        {/* <p className="air-type">{this.state.type}</p> */}
                    </div>
                    <Nav />
                </div>
                <div className="downloaddetail-detail container">
                    {this.showDocuments()}
                </div>
                <Footer />
            </div>
        )
    }
}
 
const mapStateToProps = ({ document }) => {
    return { 
        documents: document.documents
    }
}
 
export default connect(mapStateToProps, { documentFetchByBrand })(Downloaddetail)